module.exports = __webpack_public_path__ + "05_glasses_blue.b1b2be76.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/05_glasses_blue.png
// module id = HJ97
// module chunks = 0